<template>
	<div style="padding-left: 10px;padding-right: 10px;padding-top: 10px;">
		<van-list v-model:loading="loading" :finished="finished" :finished-text="$t('msg.noMore')" @load="onLoad">
			<div v-for='customer in customerList'
				style="position: relative;background-color: #FFF; border-radius: 13px;padding: 14px;margin-bottom: 14px;"
				@click="this.$router.push({ path: '/customerService', query: { id: customer.repairId, motoId: motoId, deptId: deptId, status: customer.status } })">

				<div v-if="customer.status === 0" class="newStatus">
					<p class="newText">{{ this.$t('msg.newRecord') }}</p>
				</div>
				<div v-if="customer.status === 1" class="newStatus">
					<p class="newText">{{ this.$t('msg.inProcess') }}</p>
				</div>
				<div v-if="customer.status === 2" class="endStatus">
					<p class="endText">{{ this.$t('msg.haveEnded') }}</p>
				</div>
				<p style="text-indent: 0em; font-size: 14px;color: #4E5055;">{{ $t('msg.customerNumber') }} {{
                    customer.customerNumber }}</p>
				<p style="text-indent: 0em; font-size: 12px;color: #9095A6;">{{ formatDate(new Date(customer.createTime /
                    1), 'yyyy-MM-dd hh:mm:ss') }}</p>
				<div style="background-color: #F5F5F5;border-radius: 8px;padding: 10px;margin-top: 13px;">
					<p
						style="text-indent: 0em;font-size: 14;color: #4E5055;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
						{{ customer.repair }}
					</p>
					<div v-if="customer.imgUrl != '' && customer.imgUrl != null" style="text-align: left;">
						<Image :src="customer.imgUrl" width="40px" height="40px">
							<template #error>
								<Icon type="ios-image-outline" size="24" color="#ccc" />
							</template>
						</Image>
					</div>
				</div>
			</div>
		</van-list>
	</div>
</template>

<script>
	import http from '../utils/request.js'
	import api from '../api/index.js'
	export default {
		name: "customerHistory",
		components: {},
		data() {
			return {
				motoId: '',
				deptId: '',
				loading: false,
				finished: false,
				customerList: [],
				newFrom: {
					bizType: 3,
					pageNum: 0,
					pageSize: 10
				},

			}
		},
		methods: {
			getCustomerLists() {
				this.newFrom = {
					bizType: 3,
					pageNum: 0,
					pageSize: 10
				};
				api.systemServiceApi.getCustomerLists(this.newFrom)
					.then((result) => {
						this.customerList = result.rows;
					});
			},

			onLoad() {
				this.loading = true;
				api.systemServiceApi.getCustomerLists(this.newFrom)
					.then((result) => {
						this.loading = false;
						// 添加空值检查
						if (result && result.data && result.data.rows) {
							console.log(JSON.stringify(result.data, null, 2), "88888888888")
							const newRows = result.data.rows || [];
							this.customerList = this.customerList.concat(newRows);
							this.finished = newRows.length < this.newFrom.pageSize;
						} else {
							this.finished = true;
						}
					})
					.catch(error => {
						this.loading = false;
						this.finished = true;
						console.error('加载数据出错:', error);
					});
				this.newFrom.pageNum += 1;
			},

			getStatusStr(status) {
				if (status === 0) {
					return this.$t('msg.newRecord');
				} else if (status === 1) {
					return this.$t('msg.inProcess');
				} else if (status === 2) {
					return this.$t('msg.haveEnded');
				}
			},
			formatDate(date, format) {
				let time = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds(),
					'q+': Math.floor((date.getMonth() + 3) / 3),
					'S+': date.getMilliseconds()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' +
							time[k]).length));
					}
				}
				return format;
			}
		},
		mounted() {
			this.motoId = this.$route.query.motoId;
			this.deptId = this.$route.query.deptId;
			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.historyRecord')
		}
	}
</script>

<style>
	.newStatus {
		text-align: center;
		width: 52px;
		height: 20;
		position: absolute;
		top: 0px;
		right: 14px;
		background-color: #CBF2D4;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	.newText {
		text-indent: 0em;
		font-size: 12px;
		color: #75A470;
	}

	.endStatus {
		text-align: center;
		width: 52px;
		height: 20;
		position: absolute;
		top: 0px;
		right: 14px;
		background-color: #D4D4D4;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	.endText {
		text-indent: 0em;
		font-size: 12px;
		color: #7E8187;
	}
</style>